import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class CommentsCount extends Field {
  static get disableFieldForModelNames() {
    return ['Release', 'ReleasePhase', 'Task'];
  }

  static attributesForModel() {
    return ['commentsCount'];
  }

  get title() {
    return 'Comments count';
  }

  exampleContents(): FieldContentsData {
    return { text: 4, icon: { name: 'fa-regular fa-comment' } };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.commentsCount) {
      return {
        text: record.commentsCount,
        icon: { name: 'fa-regular fa-comment' },
      };
    }

    return {};
  }
}
